// Component
import AccordionFields from 'components/AccordionFields/AccordionFields';

// Libraries
import React from 'react';
import PropTypes from 'prop-types';

const ConfigForm = ({
    data,
    testPrefix,
    isViewMode,
    paymentModeOptions,
    paymentSubModeOptions,
}) => {
    const paymentModeIndex = data.configData.findIndex(
        item => item.name === 'paymentType'
    );

    data.configData[paymentModeIndex].props.data = paymentModeOptions
        .map(mode => {
            return ['UPI', 'ACCOUNT_VERIFICATION'].includes(mode.value)
                ? false
                : mode;
        })
        .filter(Boolean);

    return (
        <>
            <div className="form-section">
                <AccordionFields
                    configData={data.configData}
                    customFieldOptions={paymentSubModeOptions}
                    name="credentials"
                    isViewMode={isViewMode}
                />
            </div>
        </>
    );
};

ConfigForm.propTypes = {
    data: PropTypes.object.isRequired,
    testPrefix: PropTypes.string,
    isViewMode: PropTypes.bool,
    paymentModeOptions: PropTypes.array,
    paymentSubModeOptions: PropTypes.array,
};

export default ConfigForm;
